import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
const CLIENT_DETAIL_QUERY_KEYS = [
    QueryKeys.CustomerDetail,
    QueryKeys.ClientContacts,
    QueryKeys.RecentAgreements,
    QueryKeys.ClientBillingOverview,
    QueryKeys.ClientFutureInvoices,
    QueryKeys.CustomerPaymentMethods
];
export const isClientDetailQuery = (queryKey)=>CLIENT_DETAIL_QUERY_KEYS.some((key)=>key === queryKey[0]);
